import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import generalReducer from "./generalSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
const store = configureStore({
  reducer: {
    user: userReducer,
    general: generalReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const userSelector = (state: RootState) => state.user;
export const generalContextSelector = (state: RootState) => state.general;
